import * as api from 'utils/axios';
import * as endpoints from 'services/scan/endpoints';
import { SCAN_API } from 'config';

export const engagementStats = (scanWaveId?: string) =>
  api.sendGet(SCAN_API + endpoints.SCAN_STATS_ENGAGEMENT(scanWaveId), {
    headers: { 'Content-Type': 'application/json', accept: 'application/json' },
    data: {},
  });
